import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import SiteNavbar from "./SiteNavbar";
import SiteFooter from "./SiteFooter";

type SiteLayoutProps = {
  children: ReactNode;
};

export default function SiteLayout({ children }: SiteLayoutProps) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [search]);

  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <SiteNavbar />
      <main className="flex-1 w-full pt-16 md:pt-[72px]">{children}</main>
      <SiteFooter />
    </div>
  );
}